// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-button {
  width: 202px;
  height: 48px;
  display: block;
  overflow: hidden;
  position: relative;
  color: #FFFFFF;
  background-color: #982D67;
  border-radius: 48px;
  outline: none;
  border: none;
  text-transform: uppercase;
  cursor: pointer;
  font-family: FixelDisplay;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
}
@media (min-width: 1620px) {
  .form-button {
    width: 254px;
    height: 62px;
    font-family: FixelDisplay;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
  }
}
@media (max-width: 550px) {
  .form-button {
    width: 100%;
  }
}
.form-button .form-button-inner-circle {
  position: absolute;
  display: block;
  width: 0px;
  height: 0px;
  border-radius: 50%;
  background-color: #812456;
  transition: width 0.4s ease-in-out, height 0.4s ease-in-out;
  transform: translate(-50%, -50%);
  z-index: 1;
}
.form-button .form-button-text {
  width: 154px;
  height: 16px;
  margin-top: 2px;
  overflow: hidden;
  white-space: nowrap;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 2;
  transform: translate(-50%, -50%);
  display: inline-block;
}
@media (min-width: 1620px) {
  .form-button .form-button-text {
    width: 192px;
    height: 22px;
  }
}
.form-button .form-button-text.top .char {
  transform: translateY(0%);
}
.form-button .form-button-text.bottom .char {
  opacity: 0;
  transform: translateY(-100%);
}
.form-button .form-button-text .char {
  display: inline-block;
}

.form-button:hover .form-button-inner-circle {
  width: 250%;
  height: 250%;
}`, "",{"version":3,"sources":["webpack://./src/components/FormSection/Form/FormButton/FormButton.scss","webpack://./src/styles/variables.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AAGA;EACI,YAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,cCNI;EDOJ,yBCRS;EDST,mBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EEPA,yBFQqB;EEPrB,eFOmC;EENnC,kBFMyC;EELzC,gBFKiD;EEJjD,iBFIsD;AAE1D;AAAI;EAfJ;IAgBQ,YAAA;IACA,YAAA;IEZJ,yBFayB;IEZzB,eFYuC;IEXvC,kBFW6C;IEV7C,gBFUqD;IETrD,iBFS0D;EAO5D;AACF;AALI;EArBJ;IAsBQ,WAAA;EAQN;AACF;AANI;EACI,kBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,2DAAA;EACA,gCAAA;EACA,UAAA;AAQR;AALI;EACI,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,gCAAA;EACA,qBAAA;AAOR;AALQ;EAbJ;IAcQ,YAAA;IACA,YAAA;EAQV;AACF;AALY;EACI,yBAAA;AAOhB;AAFY;EACI,UAAA;EACA,4BAAA;AAIhB;AAAQ;EACI,qBAAA;AAEZ;;AAGA;EACI,WAAA;EACA,YAAA;AAAJ","sourcesContent":["@use '../../../../styles/mixins.scss';\n@import '../../../../styles/variables.scss';\n\n.form-button {\n    width: 202px;\n    height: 48px;\n    display: block;\n    overflow: hidden;\n    position: relative;\n    color: $white;\n    background-color: $main-color;\n    border-radius: 48px;\n    outline: none;\n    border: none;\n    text-transform: uppercase;\n    cursor: pointer;\n    @include mixins.font(FixelDisplay, 16px, normal, 500, 100%);\n\n    @media (min-width: 1620px) {\n        width: 254px;\n        height: 62px;\n        @include mixins.font(FixelDisplay, 20px, normal, 500, 110%);\n    }\n\n    @media (max-width: 550px) {\n        width: 100%;\n    }\n\n    .form-button-inner-circle {\n        position: absolute;\n        display: block;\n        width: 0px;\n        height: 0px;\n        border-radius: 50%;\n        background-color: #812456;\n        transition: width 0.4s ease-in-out, height 0.4s ease-in-out;\n        transform: translate(-50%, -50%);\n        z-index: 1;\n    }\n\n    .form-button-text {\n        width: 154px;\n        height: 16px;\n        margin-top: 2px;\n        overflow: hidden;\n        white-space: nowrap;\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        z-index: 2;\n        transform: translate(-50%, -50%);\n        display: inline-block;\n\n        @media (min-width: 1620px) {\n            width: 192px;\n            height: 22px;\n        }\n\n        &.top {\n            .char {\n                transform: translateY(0%);\n            }\n        }\n\n        &.bottom {\n            .char {\n                opacity: 0;\n                transform: translateY(-100%);\n            }\n        }\n\n        .char {\n            display: inline-block;\n        }\n    }\n}\n\n.form-button:hover .form-button-inner-circle {\n    width: 250%;\n    height: 250%;\n}","// Colors\n\n$main-color: #982D67;\n$white: #FFFFFF;\n$light-background: #F5F5F5;\n$purple: #812456;\n$grey: #EAEAEA;\n$grey-opacity:#E0E0E0;\n$grey-dark: #575756;\n$grey-text: #BCBCBC;\n$dark: #313130;\n$red: #AE2323;\n$opacity-text: rgba(255, 255, 255, 0.50);","@mixin flex($dir, $jc, $ai) {\n    display: flex;\n    flex-direction: $dir;\n    justify-content: $jc;\n    align-items: $ai;\n}\n\n@mixin font ($font, $size, $style, $weight, $height) {\n    font-family: $font;\n    font-size: $size;\n    font-style: $style;\n    font-weight: $weight;\n    line-height: $height;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
